// Sponsor scenografici FITTIZI/dimostrativi (totem, banner, installazioni 3D stilizzate).
// Data-driven: aggiungere uno sponsor = una riga. NESSUN logo/monumento reale finché non fornito.
// Vengono posizionati attorno al centro del comune attivo (vista dettaglio) per garantirne
// la visibilità senza sovrapporsi ai POI reali.

export const DEMO_SPONSORS = [
  { id: "sp_totem_1", kind: "totem", name: "Spazio Sponsor", tag: "Il tuo brand qui", color: "#00E676" },
  { id: "sp_banner_1", kind: "banner", name: "Sagra del Territorio", tag: "Evento in evidenza", color: "#F59E0B" },
  { id: "sp_totem_2", kind: "totem", name: "Partner Locale", tag: "Spazio promozionale", color: "#7C5CFF" },
];

// Dispone gli sponsor attorno a un centro [lng,lat] su un anello (gradi).
export function sponsorItems(center, list = DEMO_SPONSORS, radiusDeg = 0.0062) {
  if (!center) return [];
  const cos = Math.cos((center[1] * Math.PI) / 180) || 1;
  const start = -Math.PI / 3;
  return list.map((s, i) => {
    const a = start + (i / Math.max(1, list.length)) * Math.PI * 1.4;
    return { ...s, lat: center[1] + Math.sin(a) * radiusDeg, lng: center[0] + (Math.cos(a) * radiusDeg) / cos };
  });
}

const esc = (s = "") => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function sponsorMarkerEl(s, onSelect) {
  const el = document.createElement("div");
  el.className = "sponsor sponsor--" + (s.kind || "totem");
  el.style.setProperty("--sc", s.color || "#00E676");
  el.setAttribute("data-testid", `sponsor-${s.id}`);
  if (s.kind === "banner") {
    el.innerHTML = `
      <div class="sp-banner"><span class="sp-banner-tag">${esc(s.tag || "")}</span><span class="sp-banner-name">${esc(s.name)}</span></div>
      <div class="sp-pole"></div><div class="sp-base"></div>`;
  } else {
    el.innerHTML = `
      <div class="sp-totem"><span class="sp-totem-name">${esc(s.name)}</span><span class="sp-totem-tag">${esc(s.tag || "")}</span></div>
      <div class="sp-pole"></div><div class="sp-base"></div><div class="sp-glow"></div>`;
  }
  el.addEventListener("click", (e) => { e.stopPropagation(); onSelect && onSelect(s); });
  return el;
}
